import { combineReducers } from "redux";
import * as actions from '../../actions/types';
import { Challenge } from "../../components/user/ChallengesPage";

const activating = (state = false, action) => {
    switch (action.type) {
        case actions.USER_CHALLENGE_ACTIVATE:
            return true;
        case actions.USER_CHALLENGE_ACTIVATE_SUCCESS:
        case actions.USER_CHALLENGE_ACTIVATE_ERROR:
            return false;
        default:
            return state;
    }
};

const challenges = (state: Array<Challenge> | null = null, action) => {
    switch (action.type) {
        case actions.USER_CHALLENGES_FETCH:
        case actions.USER_CHALLENGES_FETCH_ERROR:
            return null;
        case actions.USER_CHALLENGES_FETCH_SUCCESS:
            return action.payload;
        case actions.USER_CHALLENGE_ACTIVATE_SUCCESS:
            return state && state.map(challenge =>
                challenge.id === action.payload.id
                    ? { ...challenge, active: true }
                    : challenge
            );
        default:
            return state;
    }
};

export const getUserChallenges = (state) => state.user.challenges.challenges;
export const isUserChallengeActivating = (state) => state.user.challenges.activating;

export default combineReducers({
    activating,
    challenges
});